import firebase from 'firebase';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FB_API_apiKey,
  authDomain: process.env.REACT_APP_FB_API_authDomain,
  projectId: process.env.REACT_APP_FB_API_projectId,
  storageBucket: process.env.REACT_APP_FB_API_storageBucket,
  messagingSenderId: process.env.REACT_APP_FB_API_messagingSenderId,
  appId: process.env.REACT_APP_FB_API_appId,
  measurementId: process.env.REACT_APP_FB_API_measurementId,
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider };
export default db;
